/** @jsxImportSource @emotion/react */
import { useTranslation } from "react-i18next"
import { WEDDING_MUI_ICONS, WeddingMuiIcon, MenuIconType } from "../../../common/context/SharedFormTypes"
import { IconPicker } from "./IconPicker"
import {
    Church, Celebration, Favorite, FavoriteBorder, Diamond,
    Groups, MusicNote, PhotoCamera, CameraAlt, DirectionsCar,
    Park, LocalFlorist, Nightlife, SportsBar, CardGiftcard,
    Checkroom, TheaterComedy, Spa, FilterVintage, AutoAwesome,
    Stars, EmojiPeople, DirectionsWalk, Schedule, Place,
    Restaurant, Cake, LocalBar, WineBar, NightlightRound
} from "@mui/icons-material"

export const WEDDING_EMOJIS = [
    '💒', '💍', '👰', '🤵', '💐', '🎶', '🥂', '🎉',
    '🎊', '📸', '🕺', '💃', '💕', '❤️', '✨', '🌹',
    '🪩', '🎵', '🎤', '🥳', '🍽️', '🎂', '🚗', '⛪',
    '🌸', '💝', '🎁', '👫', '🌟', '🕐', '📍', '🎭'
]

export const WEDDING_MUI_ICON_MAP: Record<WeddingMuiIcon, React.ReactElement> = {
    Church: <Church />,
    Celebration: <Celebration />,
    Favorite: <Favorite />,
    FavoriteBorder: <FavoriteBorder />,
    Diamond: <Diamond />,
    Groups: <Groups />,
    MusicNote: <MusicNote />,
    PhotoCamera: <PhotoCamera />,
    CameraAlt: <CameraAlt />,
    DirectionsCar: <DirectionsCar />,
    Park: <Park />,
    LocalFlorist: <LocalFlorist />,
    Nightlife: <Nightlife />,
    SportsBar: <SportsBar />,
    CardGiftcard: <CardGiftcard />,
    Checkroom: <Checkroom />,
    TheaterComedy: <TheaterComedy />,
    Spa: <Spa />,
    FilterVintage: <FilterVintage />,
    AutoAwesome: <AutoAwesome />,
    Stars: <Stars />,
    EmojiPeople: <EmojiPeople />,
    DirectionsWalk: <DirectionsWalk />,
    Schedule: <Schedule />,
    Place: <Place />,
    Restaurant: <Restaurant />,
    Cake: <Cake />,
    LocalBar: <LocalBar />,
    WineBar: <WineBar />,
    NightlightRound: <NightlightRound />
}

export const getWeddingMuiIconElement = (iconName: string): React.ReactElement | null => {
    return WEDDING_MUI_ICON_MAP[iconName as WeddingMuiIcon] ?? null
}

interface ScheduleIconPickerProps {
    iconType: MenuIconType
    iconValue: string
    primaryColor: string
    onSelect: (type: MenuIconType, value: string) => void
}

export const ScheduleIconPicker = ({ iconType, iconValue, primaryColor, onSelect }: ScheduleIconPickerProps) => {
    const { t } = useTranslation()

    return (
        <IconPicker
            iconType={iconType}
            iconValue={iconValue}
            primaryColor={primaryColor}
            emojis={WEDDING_EMOJIS}
            muiIcons={WEDDING_MUI_ICONS}
            muiIconMap={WEDDING_MUI_ICON_MAP}
            label={t('questionnaire.schedule.eventDialog.icon')}
            emojiTabLabel={t('questionnaire.schedule.eventDialog.emojiTab')}
            muiTabLabel={t('questionnaire.schedule.eventDialog.muiTab')}
            onSelect={onSelect}
        />
    )
}
